


























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { userData } from '../main';
import Challenge from '../entities/Challenge';

@Component
export default class Challenges extends Vue {
    public data() {
        return {
            challenges: [],
            userData
        };
    }

    public copy(cid: string) { 
        const fullLink = document.createElement('input');
        document.body.appendChild(fullLink);
        fullLink.value = window.location.origin + '/#/?i=' + cid;
        fullLink.select();
        document.execCommand("copy", false);
        fullLink.remove();
        this.$toast.open({
            message: 'Inbjudningslänk kopierad',
            type: 'is-success'
        });
    }

    public isInChallenge(cid: string) {
        if(!userData.user.challenges)
            return;
        return userData.user.challenges.find(x => x === cid);
    }

    public joinChallenge(cid: string) {
        if(!userData.user.challenges)
            userData.user.challenges = [];
        if(userData.user.challenges.find(x => x === cid))
            userData.user.challenges = userData.user.challenges.filter(x => x !== cid) ;
        else
            userData.user.challenges.push(cid);
        userData.saveUser().then(() => userData.loadUser(userData.user)); 
    }

    public changeChallenge(cid: string) {
        userData.user.default_challenge = cid;
        userData.saveUser().then(() => userData.loadUser(userData.user));
    }

    public beforeMount() {
        userData.loadChallenges().then((c: Challenge[]) => this.$data.challenges = c);
    }
}
